export const setLoadingState = isLoading => (state, action) => {
  state.loading = isLoading;
};
